import { STATUS } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export const StatusBadge = ({ s }) => <Badge className={`status-${s} border text-sm`}>{STATUS[s] || s}</Badge>;

export const pickCardBorder = (entrega) => {
  if (entrega.prioridade === "urgente") return "border-red-500";
  if (entrega.prioridade === "vip") return "border-purple-500";
  if (entrega.status === "aguardando_conferencia") return "border-violet-600";
  if (entrega.status === "em_transito") return "border-blue-500";
  if (entrega.status === "concluida") return "border-emerald-500";
  if (entrega.status === "remarcar") return "border-rose-500";
  return "border-amber-500";
};

export const formatCellPhone = (raw) => {
  const digits = (raw || "").replace(/\D/g, "");
  if (digits.length === 11) return digits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  if (digits.length === 10) return digits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  return raw;
};

export const isReceitaRevendaMobile = (tipoNome) => {
  const t = (tipoNome || "").toLowerCase();
  return t.includes("receita") && t.includes("revenda");
};

export const chipClasses = (chip, active, count) => {
  if (active) return chip.cls;
  if (chip.k === "urgentes" && count > 0) return "bg-white text-red-700 border-red-300 animate-pulse";
  return "bg-white text-neutral-700 border-neutral-200 hover:border-orange-300";
};

// Monta a string do pedido — respeita a semântica "1 entrega = N pedidos" (fev/2026).
// Prioridade:
//  1. pedidos_multiplos com >=2 números → "#100 · #101 · #102" (mostra todos no header)
//  2. tipo Receita+Revenda → "Rec X · Rev Y"
//  3. Legado / entrega simples → numero_pedido único
// Isto garante que o entregador enxergue a entrega inteira já no card colapsado
// (bug reportado fev/2026: com multi-pedidos o card mostrava só o primeiro número).
// Multi-empresa (fev/2026): quando `tipoNome` do lookup local é vazio (entrega
// veio de outra empresa do user), cai pra `entrega.tipo_nome` populado pelo
// backend em /minhas-entregas. Sem isso, receita+revenda mostraria "sem pedido".
export const buildPedidoLabel = (entrega, tipoNome, fallback = "sem pedido") => {
  const withHash = (s) => {
    const t = String(s || "").trim();
    return t.startsWith("#") ? t : `#${t}`;
  };
  const multi = Array.isArray(entrega.pedidos_multiplos)
    ? entrega.pedidos_multiplos.map((p) => String(p || "").trim()).filter(Boolean)
    : [];
  if (multi.length >= 2) {
    return multi.map(withHash).join(" · ");
  }
  const effectiveTipoNome = tipoNome || entrega.tipo_nome || "";
  if (isReceitaRevendaMobile(effectiveTipoNome)) {
    const parts = [
      entrega.numero_pedido_receita ? `Rec ${entrega.numero_pedido_receita}` : null,
      entrega.numero_pedido_revenda ? `Rev ${entrega.numero_pedido_revenda}` : null,
    ].filter(Boolean);
    if (parts.length) return parts.join(" · ");
    // Legacy: entregas criadas antes do split ainda usam `numero_pedido` único
    return entrega.numero_pedido || fallback;
  }
  return entrega.numero_pedido || fallback;
};

// Chips de status do topo (statusFilter): valores em k conforme statusCounts.
export const STATUS_CHIPS = [
  { k: "urgentes", label: "🔥 Urgentes", cls: "bg-red-600 text-white border-red-700" },
  { k: "pendentes", label: "Pendentes", cls: "bg-orange-600 text-white border-orange-700" },
  { k: "em_transito", label: "Em rota", cls: "bg-blue-600 text-white border-blue-700" },
  { k: "aguardando", label: "Aguard.", cls: "bg-amber-500 text-white border-amber-600" },
  { k: "concluida", label: "Concluídas", cls: "bg-emerald-600 text-white border-emerald-700" },
  { k: "todas", label: "Todas", cls: "bg-neutral-800 text-white border-neutral-900" },
];
